module.exports = __webpack_public_path__ + "img/muffin-1.8a538ab5.svg";